import $http, { handleError } from '@/plugins/axios'
import { extractChapterException } from '@/utils/helpers'

const RESOURCE_NAME = '/admin/flags'

export default {
  fetchFlagsPaged (skipCount, maxResultCount, keyword) {
    return $http().get(`${RESOURCE_NAME}/paged`, {
      params: {
        skipCount,
        maxResultCount,
        keyword
      }
    })
  },
  deleteFlag (itemId) {
    const route = `${RESOURCE_NAME}/${itemId}`
    return $http().delete(route)
  },
  create (flag) {
    return $http().post(RESOURCE_NAME, this.getFormData(flag))
  },
  update (flag) {
    return $http().put(`${RESOURCE_NAME}/${flag.id}`, this.getFormData(flag), { handleError: false })
      .catch(e => {
        const chapterException = extractChapterException(e)
        if (!chapterException || !chapterException.isFlagException) {
          handleError(e)
        }
        throw e
      })
  },
  getRelatedProductsPaged (skipCount, maxResultCount, keyword) {
    return $http().get(`${RESOURCE_NAME}/pagedproducts`, {
      params: {
        skipCount: skipCount,
        maxResultCount: maxResultCount,
        keyword: keyword
      }
    })
  },
  get (id) {
    return $http().get(`${RESOURCE_NAME}/${id}`)
  },

  getFormData (flag) {
    let formData = new FormData()
    for (var key in flag) {
      // if (flag[key]) {
      let childKey = null
      if (key === 'productFile') {
        for (childKey in flag[key]) {
          if (childKey === 'productListMaps') {
            formData.append(`productFile.${childKey}`, flag[key][childKey])
          } else {
            formData.append(`productFile.${childKey}`, flag[key][childKey])
          }
        }
      } else if (key === 'products') {
        for (let index = 0; index < flag[key].length; index++) {
          formData.append(`products[${index}].id`, flag[key][index].id)
          formData.append(`products[${index}].sku`, flag[key][index].sku)
        }
      } else if (key === 'removedProducts') {
        for (let index = 0; index < flag[key].length; index++) {
          formData.append(`removedProducts[${index}].id`, flag[key][index].id)
          formData.append(`removedProducts[${index}].sku`, flag[key][index].sku)
        }
      } else if (key === 'flagType') {
        formData.append(key, ' ')
      } else {
        formData.append(key, flag[key])
      }
      // }
    }
    return formData
  }
}
